module.exports = __webpack_public_path__ + "static/img/vs.b93e43a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vs.png
// module id = KIE/
// module chunks = 1